import React from "react";
import Topbar from "../../components/Topbar/Topbar";
import Footer from "../../components/Footer/Footer"
import Buycourse from "../../components/Buycourse/Buycourse";

const Course=()=>{
    return(
        <>
            <Topbar/>
            <div className="course-container">
                <Buycourse/>
                <Footer/>
            </div>
        </>
    )
}

export default Course;